import { QUERIES } from '@repo/ui/queries';
import { themeStyle } from '@repo/ui/theming';
import styled from 'styled-components';

import { CenterChildren } from 'styles/layouts';

export const Wrapper = styled.div`
  display: grid;
  gap: 72px;

  grid-template-columns: repeat(1, 1fr);

  ${QUERIES.tabletAndUp} {
    grid-template-columns: repeat(2, 1fr);
  }

  ${QUERIES.laptopAndUp} {
    grid-template-columns: repeat(3, 1fr);
  }
`;

export const IconWrapper = styled(CenterChildren)`
  background-color: ${themeStyle.varInkLight};
  border-radius: var(--border-radius-12);
  height: 72px;
  min-width: 72px;
`;
